import api from '../../plugins/api'


export class Comentario {
    Historico: string = ''
    Nome: string = ''
    Papel: string = ''
    Data: string = ''
    Texto: string = ''
    CodLancamento: number = 0
    CodContaCorrente: number = 0
    IdDocumento: number = 0
    Pagina: number = 1
    NomeDocumento: string = ''
}

export type IncluiComentarioRequest = {
    CodCondominio: number
    Mes: number
    Ano: number
    Texto: string
    CodContaCorrente: number
    IdDocumento: number
    Pagina: number
    NomeDocumento: string
}


export type ListaComentarioRequest = {
    CodCondominio: number
    Mes: number
    Ano: number
}

export type ListaComentarioResponse = Comentario[]

export interface ComentarioRepository {
    incluir(data: IncluiComentarioRequest): Promise<void>
    lista(data: ListaComentarioRequest): Promise<ListaComentarioResponse>
}


export class ApiComentarioRepository implements ComentarioRepository {
    async incluir({ CodCondominio, Mes, Ano, CodContaCorrente, Texto, IdDocumento, NomeDocumento, Pagina }: IncluiComentarioRequest): Promise<void> {
        const { data } = await api.post<{ success: boolean, message: string }>(`/condominios/${CodCondominio}/livro-digital/comentarios/incluir`, {
            CodCondominio,
            Mes,
            Ano,
            CodContaCorrente,
            Texto,
            IdDocumento,
            NomeDocumento,
            Pagina
        })
    }
    async lista({ CodCondominio, Ano, Mes }: ListaComentarioRequest): Promise<ListaComentarioResponse> {
        const { data } = await api.get<Comentario[]>(`/condominios/${CodCondominio}/livro-digital/comentarios/lista`, {
            params: {
                CodCondominio,
                Ano,
                Mes
            }
        })

        return data
    }

}


export const comentario_repository = new ApiComentarioRepository()